import React, { useEffect } from 'react';

const GlobalAccessPage = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css";
    link.rel = "stylesheet";
    link.id = "tailwind-mutualfund"; // Add ID so you can remove it later if needed
    document.head.appendChild(link);

    return () => {
      // Optional: Clean up when component unmounts
      document.getElementById("tailwind-mutualfund")?.remove();
    };
  }, []);
  return (
    <>
      {/* <!-- Hero Section --> */}
      <section className="bg-blue-50 py-16 text-center">
        <h1 className="text-4xl font-bold text-blue-900 mb-4">Trade in Global Markets with GPS Finvest</h1>
        <p className="text-lg text-gray-700 mb-6">Open an international trading account and invest in U.S., Europe, and other global exchanges with ease.</p>
        <div ><a className="btn btn-primary" href="https://gpsfinvest.investwell.app/app/#/login">Get Started</a></div>
      </section>

      {/* <!-- What is Global Market Access --> */}
      <section className="py-16 bg-white">
        <div className='col-md-12' style={{ display: 'flex', justifyContent: 'center' }}>
          <img src='/images/gglobal.jpg' style={{ height: '300px' }} />
        </div>
        <div className="max-w-4xl mx-auto px-4 text-center mt-2">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">What is Global Market Access?</h2>
          <p className="text-lg text-gray-600">Global Market Access allows you to invest directly in international stocks, ETFs, and bonds listed on major global exchanges like NASDAQ, NYSE, London Stock Exchange, and more. Diversify your portfolio and gain exposure to top global brands and innovation leaders.</p>
        </div>
      </section>

      {/* <!-- Why Choose GPS Finvest --> */}
      <section className="py-16 bg-green-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">Why Choose GPS Finvest for Global Investing?</h2>
          <div className="grid md:grid-cols-4 gap-6 text-left">
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Account.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Open Global Account</h3>
              <p>Get access to U.S. & global stock markets with a simple online KYC.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Deposit.jpg" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Zero Minimum Deposit</h3>
              <p>Start with any amount and invest at your pace. No high entry barrier.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Multi_Support.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Multi-Currency Support</h3>
              <p>Seamless INR-to-USD conversion and global fund transfers.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Real_Time_Trading.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Real-Time Trading</h3>
              <p>Trade live in Apple, Google, Tesla, Amazon & more from your mobile.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- How to Start Global Trading --> */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">How to Start Trading in Global Markets</h2>
          <div className="grid md:grid-cols-4 gap-6 text-left">
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">1. Register</h3>
              <p>Sign up with your PAN, email and complete online KYC process.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">2. Open Global Account</h3>
              <p>Choose our partner platform to open a U.S./global trading account.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">3. Fund & Convert</h3>
              <p>Transfer funds from your Indian bank and convert to foreign currency.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">4. Start Investing</h3>
              <p>Begin trading in global stocks, ETFs, and tech giants seamlessly.</p>
            </div>
          </div>
          <div className="mt-8">
            <div ><a className="btn btn-primary" href="https://gpsfinvest.investwell.app/app/#/login"> <i className="fa-solid fa-phone"></i> Schedule Free Setup Call</a></div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-green-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Supported Exchanges & Assets</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">NYSE & NASDAQ</h3>
              <p>Trade leading U.S. companies like Apple, Tesla, Amazon, and Google.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">ETFs & Index Funds</h3>
              <p>Access diversified investment options such as S&P 500, QQQ, and more.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Bonds & ADRs</h3>
              <p>Invest in global bonds and international companies via ADRs.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">IFSC-GIFT City</h3>
              <p>Trade via India's International Financial Services Centre (GIFT City) in USD.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Fractional Shares</h3>
              <p>Start investing in global stocks with as little as $1 using fractional ownership.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Commodities & REITs</h3>
              <p>Gain access to gold, oil ETFs, and real estate investment trusts globally.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- FAQs --> */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Frequently Asked Questions</h2>
          <div className="text-left space-y-6">
            <div>
              <h3 className="font-semibold text-blue-800">Is it legal to invest in U.S. stock markets from India?</h3>
              <p className="text-gray-600">Yes, it is completely legal under the RBI’s Liberalized Remittance Scheme (LRS). You can remit up to $250,000 per financial year.</p>
            </div>
            <div>
              <h3 className="font-semibold text-blue-800">Are there any tax implications?</h3>
              <p className="text-gray-600">Yes, gains from international stocks are taxed as per capital gains rules. We help you with basic tax reporting guidance.</p>
            </div>
            <div>
              <h3 className="font-semibold text-blue-800">Do I need a U.S. bank account?</h3>
              <p className="text-gray-600">No, you only need a PAN, Indian bank account, and valid address/KYC documents to get started.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Compliance Disclaimer --> */}
      <section className="py-12 bg-gray-100 text-center text-sm text-gray-600 px-4">
        <div className="max-w-4xl mx-auto">
          <p><strong>Disclaimer:</strong> Global investing services provided by GPS Finvest are facilitated through SEBI-registered and RBI-compliant partner platforms. All investment decisions are subject to market risk. Please read all scheme-related documents carefully. Past performance is not indicative of future returns. Ensure your compliance under LRS guidelines before investing abroad.</p>
        </div>
      </section>
    </>
  );
};

export default GlobalAccessPage;
